import { greaterThan, isPositive, subtract } from "dinero.js";
import { Immutable } from "immer";
import React from "react";

import { IBasket } from "../../../models/catalogue";
import { Dinero, getDinero } from "../../../utils/money";
import { BasketAllSavings } from "../BasketAllSavings";

import styles from "./common.module.scss";

export const BasketSavingsRow = (
    props: Immutable<{
        basket: IBasket;
        retailSubtotal: Dinero;
        totalDiscount: Dinero;
    }> & {
        removeVoucherCode: (code: string) => void;
    },
): React.ReactNode => {
    const effectiveSubtotal = getDinero(
        props.basket.total_excl_tax_excl_discounts,
    );
    const hasOscarAdjustment = greaterThan(
        props.retailSubtotal,
        effectiveSubtotal,
    );
    const totalDiscount = props.totalDiscount;
    const hasDiscounts = isPositive(totalDiscount);
    // Check if Post Order actions are present and are NOT marked to be hidden
    const postOrderActions = props.basket.offer_post_order_actions
        .concat(props.basket.voucher_post_order_actions)
        .filter((action) => !action.is_hidden);

    if (!hasDiscounts && !hasOscarAdjustment && postOrderActions.length <= 0) {
        return null;
    }

    const totalOscarDiscount = subtract(
        props.retailSubtotal,
        effectiveSubtotal,
    );
    return (
        <div className={styles.line}>
            <BasketAllSavings
                offerDiscounts={props.basket.offer_discounts}
                voucherDiscounts={props.basket.voucher_discounts}
                offerPostOrderActions={props.basket.offer_post_order_actions}
                voucherPostOrderActions={
                    props.basket.voucher_post_order_actions
                }
                removeVoucherCode={props.removeVoucherCode}
                totalOscarDiscount={totalOscarDiscount}
                hasOscarAdjustment={hasOscarAdjustment}
            />
        </div>
    );
};
